module.exports = __webpack_public_path__ + "img/swz.cfb8269f.svg";